import { createContext, useContext } from "react";
import { NavigationOption, PageType } from "./type";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface INavigationProps {}

export interface INavigationModule {
  push: <T extends INavigationProps>(
    page: PageType,
    props: T,
    option?: NavigationOption,
    anchor?: string
  ) => void;
  change: <T extends INavigationProps>(
    page: PageType,
    props: T,
    option?: NavigationOption,
    anchor?: string
  ) => void;
  back: (option?: NavigationOption) => void;
}

const NavigationModuleContext = createContext({} as INavigationModule);

export const NavigationModuleProvider = (props: {
  children: any;
  module: INavigationModule;
}) => {
  return (
    <NavigationModuleContext.Provider value={props.module}>
      {props.children}
    </NavigationModuleContext.Provider>
  );
};

export const useNavigationModule = () => useContext(NavigationModuleContext);
